var comm = new Communications(HANDLERCLASSNAME);
